<template>
  <div class="border border-ocean-200 w-full rounded-md">
    <div class="w-full px-4 md:px-6 py-4 rounded-t-md bg-ocean-50">
      <span class="text-ocean-900 font-bold text-base leading-5">{{ title }}</span>
    </div>
    <div class="rounded-md grid grid-cols-2 gap-0 font-normal text-base leading-5">
      <component
        :is="getLink(item) ? 'a' : 'div'"
        v-for="(item, key) in getFilteredOptions(options)"
        :key="key"
        :href="getLink(item)"
        class="col-span-1 px-4 md:px-6 py-4 relative"
        :class="['text-neutral-800', getRowClass(key, item)]"
        @blur="() => onRowMouseLeave(item)"
        @mouseleave="() => onRowMouseLeave(item)"
      >
        <span
          class="overflow-hidden line-clamp-4 text-ellipsis"
          @mouseenter="() => onRowMouseEnter(item)"
          @focus="() => onRowMouseEnter(item)"
        >
          {{ getName(item) }}
        </span>
        <div
          v-if="getDescription(item) && item.isOpen"
          class="xl:inline relative"
        >
          <a
            class="block group"
            :href="getLink(item)"
          >
            <div class="xl:w-[22rem] xl:inline absolute mt-1 bg-white border z-30 rounded-md drop-shadow-md p-2 md:p-4 min-w-sm md:min-w-auto group-hover:bg-ocean-50 transition">
              <div class="flex justify-between items-start">
                <div class="mr-2 text-base leading-5 flex-1 line-clamp-2 text-ellipsis">
                  {{ getName(item) }}
                </div>
                <fa
                  v-if="getLink(item)"
                  :icon="['fal', 'external-link-alt']"
                  class="fa-fw mt-1 text-ocean-700"
                />
              </div>
              <div class="mt-2 text-neutral-500 group-hover:text-ocean-700 transition text-sm">
                {{ getDescription(item) }}
              </div>
            </div>
          </a>
        </div>
      </component>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VetsterSymptomTable',

  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      options: this.items,
    };
  },

  mounted() {
    if (this.options.length % 2 === 1) {
      this.options.push({
        name: '',
        description: null,
      });
    }
  },

  methods: {
    getFilteredOptions(options) {
      return options.filter((item) => {
        const hasValidName = (item.item_name && item.item_name.trim() !== '') || (item.name && item.name.trim() !== '');
        const hasValidLink = !!item.item_link;
        const hasValidDescription = !!item.item_description;
        const hasValidConditionData = (item.condition && item.condition.data !== null) || (item.condition?.slug);
        const hasValidSymptomData = (item.symptom && item.symptom.data !== null) || (item.symptom?.slug);

        return hasValidName
          || hasValidLink
          || hasValidDescription
          || hasValidConditionData
          || hasValidSymptomData;
      });
    },
    getName(item) {
      return item.item_name
        || item.symptom?.data?.attributes?.title
        || item.symptom?.title
        || item.condition?.data?.attributes?.title
        || item.condition?.title;
    },
    getDescription(item) {
      return item.item_description
        || item.symptom?.data?.attributes?.intro
        || item.symptom?.intro
        || item.condition?.data?.attributes?.intro
        || item.condition?.intro;
    },
    getLink(item) {
      return item.item_link
        || this.getPetHealthSpeciesUrl(item.symptom?.data?.attributes || item.symptom, 'symptoms')
        || this.getPetHealthSpeciesUrl(item.condition?.data?.attributes || item.condition, 'conditions');
    },
    getPetHealthSpeciesUrl(post, slug) {
      if (post?.slug) {
        const species = post.species_type?.data?.attributes?.slug
          || post.species_type?.slug
          || post.species_types?.[0]?.slug;

        // PHP route('resources.pet-health-condition.species.show')
        // or route('resources.pet-health-symptom.species.show')
        if (species) {
          return `/en/${slug}/${species}/${post.slug}`;
        }
      }

      return null;
    },
    getRowClass(index, item) {
      let cls = '';
      if (item.isOpen || this.getLink(item)) {
        cls += ' hover:text-ocean-700 underline transition';
      }
      if (this.getLink(item)) {
        cls += ' cursor-pointer';
      } else if (this.getDescription(item)) {
        cls += ' cursor-help';
      }
      if (index % 2 === 0) {
        cls += ' border-r';
      }

      return (
        cls + (index % 4 === 0 || index % 4 === 1 ? ' bg-white' : ' bg-neutral-50')
      );
    },
    onRowClick(item) {
      if (this.getDescription(item)) {
        if (item.isOpen) {
          // eslint-disable-next-line no-param-reassign
          item.isOpen = !item.isOpen;
        } else {
          this.$set(item, 'isOpen', true);
        }
      }
    },
    onRowMouseEnter(item) {
      if (this.getDescription(item)) {
        if (item.isOpen) {
          // eslint-disable-next-line no-param-reassign
          item.isOpen = true;
        } else {
          this.$set(item, 'isOpen', true);
        }
      }
    },
    onRowMouseLeave(item) {
      if (item.isOpen) {
        // eslint-disable-next-line no-param-reassign
        item.isOpen = false;
      }
    },
  },
};
</script>
